import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Target, Eye, CheckCircle2, ArrowRight } from "lucide-react";
import { company, stats, whyUs } from "../mock";
import {
  ShieldCheck as SC,
  Wallet,
  Clock,
  HeartHandshake,
} from "lucide-react";

const iconMap = { ShieldCheck: SC, Wallet, Clock, HeartHandshake };

const About = () => {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="relative">
      <section className="relative overflow-hidden">
        <div className="aurora bg-[#8ec4ec] h-80 w-80 -top-20 -left-16" />
        <div className="aurora bg-[#8ec4ec] h-80 w-80 top-0 right-0" />
        <div className="max-w-7xl mx-auto px-6 pt-16 pb-12 text-center relative z-10 fade-up">
          <h1 className="font-display text-4xl md:text-5xl font-extrabold text-[#0a2b52]">
            About <span className="brand-gradient-text">Cloverdale Insurance</span>
          </h1>
          <p className="mt-5 text-lg text-slate-600 max-w-3xl mx-auto leading-relaxed">
            At {company.legalName}, we are committed to providing financial
            security for you and your family. Our insurance agents help make sure
            your protection has the right features, so you're covered when you
            need it most — and our agency is open 7 days a week.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6">
        <div className="glass-strong rounded-3xl grid grid-cols-2 md:grid-cols-4 divide-x divide-slate-200/60">
          {stats.map((s) => (
            <div key={s.label} className="px-6 py-8 text-center">
              <div className="font-display text-3xl md:text-4xl font-extrabold brand-gradient-text">
                {s.value}
              </div>
              <div className="text-sm text-slate-500 mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 pt-16 grid md:grid-cols-2 gap-6">
        <div className="glass rounded-3xl p-8 card-hover">
          <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-[#0066b3] to-[#003c7a] flex items-center justify-center text-white mb-4">
            <Target size={24} />
          </div>
          <h2 className="font-display text-2xl font-bold text-[#0a2b52]">
            Our Mission
          </h2>
          <p className="text-slate-600 mt-3 leading-relaxed">
            To provide the Surrey community with honest, affordable and
            personalized insurance solutions — from home and auto to business,
            travel and Super Visa coverage — all under one trusted roof.
          </p>
        </div>
        <div className="glass rounded-3xl p-8 card-hover">
          <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-[#0066b3] to-[#003c7a] flex items-center justify-center text-white mb-4">
            <Eye size={24} />
          </div>
          <h2 className="font-display text-2xl font-bold text-[#0a2b52]">
            Our Promise
          </h2>
          <p className="text-slate-600 mt-3 leading-relaxed">
            As an independent broker, we shop multiple leading insurers on your
            behalf to find the best coverage and rate. We offer monthly payment
            plans and even free delivery service to surrounding areas.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 pt-16">
        <h2 className="font-display text-3xl font-extrabold text-[#0a2b52] text-center mb-10">
          Why choose us
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {whyUs.map((w) => {
            const Icon = iconMap[w.icon] || SC;
            return (
              <div key={w.title} className="glass rounded-3xl p-6 card-hover">
                <div className="h-11 w-11 rounded-xl bg-gradient-to-br from-[#0066b3] to-[#003c7a] flex items-center justify-center text-white mb-3">
                  <Icon size={22} />
                </div>
                <h4 className="font-display font-bold text-[#0a2b52]">
                  {w.title}
                </h4>
                <p className="text-sm text-slate-600 mt-1.5 leading-relaxed">
                  {w.desc}
                </p>
              </div>
            );
          })}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 pt-16">
        <div className="glass-strong rounded-3xl p-10 md:p-14 text-center relative overflow-hidden">
          <div className="aurora bg-[#cfe4f6] h-64 w-64 -bottom-24 -right-10" />
          <ShieldCheck size={40} className="text-[#0066b3] mx-auto mb-4" />
          <h2 className="font-display text-3xl font-extrabold text-[#0a2b52] relative">
            Ready to protect what matters most?
          </h2>
          <p className="text-slate-600 mt-3 max-w-xl mx-auto relative">
            Get your free, no-obligation quote today and let our agents help you
            save.
          </p>
          <Link
            to="/contact"
            className="brand-btn inline-flex items-center gap-2 px-7 py-3.5 rounded-full font-semibold mt-7 relative"
          >
            Get a Free Quote <ArrowRight size={18} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;
